/** Product-facing labels only; provider identifiers and captured payloads stay unchanged. */
export const browserAgentDisplayText = (value: string): string => value.replace(
  /(^|[^a-z0-9])(?:loops?[._])?jev(?:[-_](?:ultrafast|latest))?(?=$|[^a-z0-9])/gi,
  '$1Browser agent',
);
